import { render, staticRenderFns } from "./AmsSyncResultsList.vue?vue&type=template&id=c5da8fb0&scoped=true&"
import script from "./AmsSyncResultsList.ts?vue&type=script&lang=js&"
export * from "./AmsSyncResultsList.ts?vue&type=script&lang=js&"
import style0 from "./AmsSyncResultsList.vue?vue&type=style&index=0&id=c5da8fb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5da8fb0",
  null
  
)

export default component.exports